import { render, staticRenderFns } from "./TheIcon.vue?vue&type=template&id=6e78524c"
import script from "./TheIcon.vue?vue&type=script&lang=ts"
export * from "./TheIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports